import { render, staticRenderFns } from "./tabHeader.vue?vue&type=template&id=46f7fc3c&scoped=true"
import script from "./tabHeader.vue?vue&type=script&lang=js"
export * from "./tabHeader.vue?vue&type=script&lang=js"
import style0 from "./tabHeader.vue?vue&type=style&index=0&id=46f7fc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f7fc3c",
  null
  
)

export default component.exports